import ActionTypes from '../actions/actionTypes';

const initialState = {
  plasticTypesListLoading: false,
  plasticTypesListLoaded: false,
  plasticTypesListError: false,
  plasticTypesList: [],
  plasticTypesResultSize: 0,

  plasticTypeLoading: false,
  plasticTypeLoaded: false,
  plasticTypeError: false,
  plasticType: null,

  createPlasticTypeLoading: false,
  createPlasticTypeLoaded: false,
  createPlasticTypeError: false,
  createPlasticTypeErrorMessage: '',

  updatePlasticTypeLoading: false,
  updatePlasticTypeLoaded: false,
  updatePlasticTypeError: false,

  scheduledMaintenance: null,
  scheduledMaintenanceLoading: false,
  scheduledMaintenanceLoaded: false,
  scheduledMaintenanceError: false, 

  scheduledMaintenanceList: [],
  scheduledMaintenanceListSize: 0,
  scheduledMaintenanceListLoading: false,
  scheduledMaintenanceListLoaded: false, 
  scheduledMaintenanceListError: false,

  createScheduledMaintenanceLoading: false,
  createScheduledMaintenanceLoaded: false,
  createScheduledMaintenanceError: false,
  createScheduledMaintenanceErrorMessage: '',

  updateScheduledMaintenanceLoading: false,
  updateScheduledMaintenanceLoaded: false,
  updateScheduledMaintenanceError: false,
  updateScheduledMaintenanceErrorMessage: '',

  deleteScheduledMaintenanceLoading: false,
  deleteScheduledMaintenanceLoaded: false,
  deleteScheduledMaintenanceError: false,
};

export function maintenanceReducer(state = initialState, { type, payload }) {
  switch (type) {
    case ActionTypes.MAINTENANCE.PLASTIC_TYPES_LIST.REQUEST:
      return {
        ...state,
        plasticTypesListLoading: true,
        plasticTypesListLoaded: false,
        plasticTypesListError: false
      };
    case ActionTypes.MAINTENANCE.PLASTIC_TYPES_LIST.SUCCESS:
      return {
        ...state,
        plasticTypesListLoading: false,
        plasticTypesListLoaded: true,
        plasticTypesList: payload.plasticTypesList,
        plasticTypesListResultSize: payload.plasticTypesListResultSize
      };
    case ActionTypes.MAINTENANCE.PLASTIC_TYPES_LIST.FAILURE:
      return {
        ...state,
        plasticTypesListLoading: false,
        plasticTypesListError: true,
      };
    case ActionTypes.MAINTENANCE.PLASTIC_TYPE.REQUEST:
      return {
        ...state,
        plasticTypeLoading: true,
        plasticTypeLoaded: false,
        plasticTypeError: false,
        plasticType: null
      };
    case ActionTypes.MAINTENANCE.PLASTIC_TYPE.SUCCESS:
      return {
        ...state,
        plasticTypeLoading: false,
        plasticTypeLoaded: true,
        plasticType: payload.plasticType
      };
    case ActionTypes.MAINTENANCE.PLASTIC_TYPE.FAILURE:
      return {
        ...state,
        plasticTypeLoading: false,
        plasticTypeError: true,
      };
    case ActionTypes.MAINTENANCE.PLASTIC_TYPE_RESET.REQUEST:
      return {
        ...state,
        plasticType: null
      };
    case ActionTypes.MAINTENANCE.CREATE_PLASTIC_TYPE.REQUEST:
      return {
        ...state,
        createPlasticTypeLoading: true,
        createPlasticTypeLoaded: false,
        createPlasticTypeError: false,
        createPlasticTypeErrorMessage: ''
      };
    case ActionTypes.MAINTENANCE.CREATE_PLASTIC_TYPE.SUCCESS:
      return {
        ...state,
        createPlasticTypeLoading: false,
        createPlasticTypeLoaded: true
      };
    case ActionTypes.MAINTENANCE.CREATE_PLASTIC_TYPE.FAILURE:
      return {
        ...state,
        createPlasticTypeLoading: false,
        createPlasticTypeError: true,
        createPlasticTypeErrorMessage: payload.errorMessage
      };
    case ActionTypes.MAINTENANCE.CREATE_PLASTIC_TYPE.RESET:
      return {
        ...state,
        createPlasticTypeLoading: false,
        createPlasticTypeLoaded: false,
        createPlasticTypeError: false,
        createPlasticTypeErrorMessage: '',
      };
    case ActionTypes.MAINTENANCE.UPDATE_PLASTIC_TYPE.REQUEST:
      return {
        ...state,
        updatePlasticTypeLoading: true,
        updatePlasticTypeLoaded: false,
        updatePlasticTypeError: false
      };
    case ActionTypes.MAINTENANCE.UPDATE_PLASTIC_TYPE.SUCCESS:
      return {
        ...state,
        updatePlasticTypeLoading: false,
        updatePlasticTypeLoaded: true
      };
    case ActionTypes.MAINTENANCE.UPDATE_PLASTIC_TYPE.FAILURE:
      return {
        ...state,
        updatePlasticTypeLoading: false,
        updatePlasticTypeError: true
      };
    case ActionTypes.MAINTENANCE.UPDATE_PLASTIC_TYPE.RESET:
      return {
        ...state,
        updatePlasticTypeLoading: false,
        updatePlasticTypeLoaded: false,
        updatePlasticTypeError: false,
      };
    default:
      return state;
  }
}

export function scheduledMaintenanceReducer(state = initialState, { type, payload }) {
  switch (type) {
    case ActionTypes.MAINTENANCE.GET_SCHEDULE.REQUEST:
      return {
        ...state,
        scheduledMaintenanceLoading: true,
        scheduledMaintenanceLoaded: false,
        scheduledMaintenanceError: false,
        scheduledMaintenance: null
      };
    case ActionTypes.MAINTENANCE.GET_SCHEDULE.SUCCESS:
      return {
        ...state,
        scheduledMaintenanceLoading: false,
        scheduledMaintenanceLoaded: true,
        scheduledMaintenance: payload.scheduledMaintenance
      };
    case ActionTypes.MAINTENANCE.GET_SCHEDULE.FAILURE:
      return {
        ...state,
        scheduledMaintenanceLoading: false,
        scheduledMaintenanceError: true,
      };
    case ActionTypes.MAINTENANCE.GET_SCHEDULES_LIST.REQUEST:
      return {
        ...state,
        scheduledMaintenanceListLoading: true,
        scheduledMaintenanceListLoaded: false,
        scheduledMaintenanceListError: false,
        scheduledMaintenanceList: [],
        scheduledMaintenanceListSize: 0,
      };
    case ActionTypes.MAINTENANCE.GET_SCHEDULES_LIST.SUCCESS:
      return {
        ...state,
        scheduledMaintenanceListLoading: false,
        scheduledMaintenanceListLoaded: true,
        scheduledMaintenanceList: payload.scheduledMaintenanceList,
        scheduledMaintenanceListSize: payload.scheduledMaintenanceListSize
      };
    case ActionTypes.MAINTENANCE.GET_SCHEDULES_LIST.FAILURE:
      return {
        ...state,
        scheduledMaintenanceListLoading: false,
        scheduledMaintenanceListError: true,
      };
    case ActionTypes.MAINTENANCE.CREATE_SCHEDULE.REQUEST:
      return {
        ...state,
        createScheduledMaintenanceLoading: true,
        createScheduledMaintenanceLoaded: false,
        createScheduledMaintenanceError: false,
        createScheduledMaintenanceErrorMessage: ''
      };
    case ActionTypes.MAINTENANCE.CREATE_SCHEDULE.SUCCESS:
      return {
        ...state,
        createScheduledMaintenanceLoading: false,
        createScheduledMaintenanceLoaded: true
      };
    case ActionTypes.MAINTENANCE.CREATE_SCHEDULE.FAILURE:
      return {
        ...state,
        createScheduledMaintenanceLoading: false,
        createScheduledMaintenanceError: true,
        createScheduledMaintenanceErrorMessage: payload.errorMessage
      };
    case ActionTypes.MAINTENANCE.CREATE_SCHEDULE.RESET:
      return {
        ...state,
        createScheduledMaintenanceLoaded: false,
        createScheduledMaintenanceLoading: false,
        createScheduledMaintenanceError: false,
        createScheduledMaintenanceErrorMessage: '',
      };
    case ActionTypes.MAINTENANCE.UPDATE_SCHEDULE.REQUEST:
      return {
        ...state,
        updateScheduledMaintenanceLoading: true,
        updateScheduledMaintenanceLoaded: false,
        updateScheduledMaintenanceError: false,
      };
    case ActionTypes.MAINTENANCE.UPDATE_SCHEDULE.SUCCESS:
      return {
        ...state,
        updateScheduledMaintenanceLoading: false,
        updateScheduledMaintenanceLoaded: true,
      };
    case ActionTypes.MAINTENANCE.UPDATE_SCHEDULE.FAILURE:
      return {
        ...state,
        updateScheduledMaintenanceLoading: false,
        updateScheduledMaintenanceError: true,
        updateScheduledMaintenanceErrorMessage: payload.errorMessage,
      };
    case ActionTypes.MAINTENANCE.UPDATE_SCHEDULE.RESET:
      return {
        ...state,
        updateScheduledMaintenanceLoading: false,
        updateScheduledMaintenanceError: false,
        updateScheduledMaintenanceErrorMessage: '',
        updateScheduledMaintenanceLoaded: false,
      };
    case ActionTypes.MAINTENANCE.DELETE_SCHEDULE.REQUEST:
      return {
        ...state,
        deleteScheduledMaintenanceLoading: true,
        deleteScheduledMaintenanceLoaded: false,
        deleteScheduledMaintenanceError: false
      };
    case ActionTypes.MAINTENANCE.DELETE_SCHEDULE.SUCCESS:
      return {
        ...state,
        deleteScheduledMaintenanceLoading: false,
        deleteScheduledMaintenanceLoaded: true
      };
    case ActionTypes.MAINTENANCE.DELETE_SCHEDULE.FAILURE:
      return {
        ...state,
        deleteScheduledMaintenanceLoading: false,
        deleteScheduledMaintenanceError: true
      };
    case ActionTypes.MAINTENANCE.DELETE_SCHEDULE.RESET:
      return {
        ...state,
        deleteScheduledMaintenanceLoading: false,
        deleteScheduledMaintenanceLoaded: false,
        deleteScheduledMaintenanceError: false
      };
    default:
      return state;
  }
}
